import { render, staticRenderFns } from "./StatusIconKuper.vue?vue&type=template&id=3ecc244e&scoped=true&"
import script from "./StatusIconKuper.vue?vue&type=script&lang=js&"
export * from "./StatusIconKuper.vue?vue&type=script&lang=js&"
import style0 from "./StatusIconKuper.vue?vue&type=style&index=0&id=3ecc244e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ecc244e",
  null
  
)

export default component.exports